import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const getPaymentMethods = createAsyncThunk(
  "paymentMethods/getPaymentMethods", 
  async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/api-admin/get-payment-methods`
    );
    return response.data;
  }
);

export const editPaymentMethods = createAsyncThunk(
  "paymentMethods/editPaymentMethods",
  async (data) => {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api-admin/edit-payment-methods`,
      data
    );
    return response.data;
  }
);

const initialState = {
  paymentMethods: [],
  loading: false,
  error: null,
};

const paymentMethodSlice = createSlice({
  name: "paymentMethod",
  initialState,
  reducers: {
    editArray: (state, action) => {
      const newData = action.payload;
      const index = state.paymentMethods.findIndex((item) => item.id === newData.id);
      if (index !== -1) {
        state.paymentMethods[index] = { ...state.paymentMethods[index], ...newData };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentMethods.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPaymentMethods.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentMethods = action.payload.data;
      })
      .addCase(getPaymentMethods.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(editPaymentMethods.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editPaymentMethods.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentMethods = action.payload.data;
      })
      .addCase(editPaymentMethods.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { editArray } = paymentMethodSlice.actions;
export default paymentMethodSlice.reducer; 